import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-text selection:bg-brand-green/20" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <StatsBar data-id="element-3" />
        <TransformationSection data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <KitContentsSection data-id="element-6" />
        <InstantAccessSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <AboutSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <FinalCTASection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />
    </div>;
}